<script>

import {axios} from "../../mixins";

export default {
  name: 'DocusignEmbed',

  mixins: [axios],

  props: {
    title: {
      required: true,
      type: String
    },
    message: {
      required: true,
      type: String,
    },
    none: {
      required: true,
      type: Boolean
    },
    route: {
      required: false,
      type: String
    },
    token: {
      required: false,
      type: String,
      default: ''
    }
  },

  data() {
    return {
      hasEnvelope: false
    }
  },

  mounted: function () {
    this.hasEnvelope = !this.none
    if (!this.hasEnvelope) {
      window.setInterval(() => {
        this.checkForEnvelope(this.token)
      }, 10000)
    }
  },

  methods: {
    checkForEnvelope(token)
      {
        let arg
        if (!this.hasEnvelope) {
          arg = (this.token !== '') ? '&checkForEnvelope=true' : '?checkForEnvelope=true'
          this.get(this.route + arg).then((response) => {
            if (response.data.hasEnvelope) {
              window.location.reload()
            }
          }).catch((exception) => {
            // don't update anything, let the function try again
          })
        }
        // Job's Done
      },
    },
};


</script>

<template>
  <div v-if="!this.hasEnvelope" class="text-xl text-center p-4 bg-secondary rounded-lg">
    <i class="fas fa-spinner-third fa-spin block text-4xl mx-auto"></i>

    {{ this.message }}
  </div>
  <div v-else>
    <iframe class="w-full h-screen" :src="this.route" :title="this.title "></iframe>
  </div>
</template>
